import { Box, TextField } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { WebServiceLayerType } from "shared/common/stores/sidebarStore";

const Wfs20Options = ({
  webServiceLayer,
  useOldConnection,
}: {
  webServiceLayer: WebServiceLayerType;
  useOldConnection: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection={"column"} gap={2}>
      <TextField
        label={t("add_layer.namespaces")}
        variant="outlined"
        size="small"
        defaultValue={
          (useOldConnection && webServiceLayer?.source_options?.namespace) || ""
        }
        sx={{ width: { xs: "100%", md: "calc(60% - 8px)" } }}
        onChange={(event) => {
          if (!webServiceLayer.source_options) {
            webServiceLayer.source_options = {};
          }
          webServiceLayer.source_options.namespace = event.target.value;
        }}
      />
      <TextField
        label={t("add_layer.fetch_options")}
        variant="outlined"
        size="small"
        multiline
        defaultValue={
          (useOldConnection &&
            webServiceLayer?.source_options?.fetch_options) ||
          ""
        }
        minRows={4}
        sx={{ width: { xs: "100%", md: "calc(60% - 8px)" } }}
        onChange={(event) => {
          if (!webServiceLayer.source_options) {
            webServiceLayer.source_options = {};
          }
          webServiceLayer.source_options.fetch_options = event.target.value;
        }}
      />
    </Box>
  );
};
export default Wfs20Options;
